document.addEventListener('DOMContentLoaded', function() {

    const chooseAnotherPlanButton = document.getElementById('chooseAnotherPlan');
    const planSelection = document.getElementById('planSelection');
    const registrationFormContainer = document.getElementById('registrationFormContainer');
    const standardPlanDetails = document.getElementById('standardPlanDetails');
    const premiumPlanDetails = document.getElementById('premiumPlanDetails');
    const bookPlanDetails = document.getElementById('bookPlanDetails');
    const bookText = document.getElementById('bookText');
    const planText = document.getElementById('planText');
    const registrationForm = document.getElementById('registrationForm');
 
    function resetForm() { 
        registrationForm.reset();
 
        const inputs = registrationForm.querySelectorAll('input');
        inputs.forEach(function(input) {
            input.classList.remove('is-invalid');
            input.classList.remove('is-valid');
 
            const errorElement = document.querySelector(`#${input.id}-error`);
            if (errorElement) {
                errorElement.textContent = '';
            }
        }); 
        if ($.fn.validate) {
            $(registrationForm).validate().resetForm();
        }
    }

    chooseAnotherPlanButton?.addEventListener('click', function() {         
        location.reload();
    });
    
   //const oldPlanOption = '{{ old('plan_option') }}';
   const oldPlanOption = window.appData?.oldPlanOption;

   if (oldPlanOption === 'challenge') {
       showForm('challenge');
   } else if (oldPlanOption === 'standard') {
       showForm('standard');
   } else if (oldPlanOption === 'premium') {
       showForm('premium');
   }
 
    // Toggle for password field
    const togglePassword = document.querySelector('.toggle-password');
    const passwordField = document.getElementById('password');
    const togglePasswordIcon = document.getElementById('togglePasswordIcon');

    if (togglePassword && passwordField) {
        togglePassword.addEventListener('click', function() {
            const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
            passwordField.setAttribute('type', type);
            togglePasswordIcon.classList.toggle('fa-eye-slash');
        });
    }

    // Toggle for confirmation password field
    const toggleConfirmPassword = document.querySelector('.toggle-password-confirmation');
    const confirmPasswordField = document.getElementById('password_confirmation');
    const toggleConfirmPasswordIcon = document.getElementById('toggleConfirmPasswordIcon');

    if (toggleConfirmPassword && confirmPasswordField) {
        toggleConfirmPassword.addEventListener('click', function() {
            const type = confirmPasswordField.getAttribute('type') === 'password' ? 'text' : 'password';
            confirmPasswordField.setAttribute('type', type);
            toggleConfirmPasswordIcon.classList.toggle('fa-eye-slash');
        });
    }
 
    const bookOwnerOption = document.getElementById('book_owner_option');
    const promoCodeOption = document.getElementById('promo_code_option');
    const challengeAnswerSection = document.getElementById('challenge_answer_section');
    const promoCodeSection = document.getElementById('promo_code_section');
     
    function toggleOption() { 
        if (bookOwnerOption && challengeAnswerSection && promoCodeSection) {
            if (bookOwnerOption.checked) {
                challengeAnswerSection.style.display = 'block'; 
                promoCodeSection.style.display = 'none'; 
            } else if (promoCodeOption && promoCodeOption.checked) {
                challengeAnswerSection.style.display = 'none'; 
                promoCodeSection.style.display = 'block'; 
            }
        }
    }
     
    if (bookOwnerOption) {
        bookOwnerOption.addEventListener('change', toggleOption);
    }
    
    if (promoCodeOption) {
        promoCodeOption.addEventListener('change', toggleOption);
    }    
 
    toggleOption();
    
    const challengePageElement = document.getElementById('challenge_page');
    let challengePage = '';
    
    if (challengePageElement) {
        challengePage = challengePageElement.innerText;
    }
    
    const formHeader = document.getElementById('formHeader'); 
    const challengeAnswerInput = document.getElementById('challenge_answer');
    const challengeErrorDiv = document.getElementById('challenge-error'); 
    const promoCodeInput = document.getElementById('promo_code'); 
    const challengeOptionSection = document.getElementById('challenge_option_section');
    const registerButton = document.getElementById('registerButton');
    const form = document.getElementById('registrationForm'); 
    const proceedToPaymentButton = document.getElementById('proceedToPayment');
    const planOptionInput = document.getElementById('plan_option');
    const loader = document.getElementById('loader'); 
    let stripe;

    var stdPlanSection = document.getElementById('std-plan');
    var prmPlanSection = document.getElementById('prm-plan');

    if (window.appData.stripeKey) {
        try {
            stripe = Stripe(window.appData.stripeKey);
 
            if (stdPlanSection) stdPlanSection.style.display = 'block';
            if (prmPlanSection) prmPlanSection.style.display = 'block';

        } catch (e) {
            console.warn('Stripe initialization failed:', e);
            if (stdPlanSection) stdPlanSection.style.display = 'none';
            if (prmPlanSection) prmPlanSection.style.display = 'none';
        }
    } else {
        console.warn('Stripe key is not set. Skipping Stripe initialization.');
        if (stdPlanSection) stdPlanSection.style.display = 'none'; 
        if (prmPlanSection) prmPlanSection.style.display = 'none'; 
    }

    let emailValidationTimeout;
 
    if (registerButton) {
        registerButton.addEventListener('click', function(event) {
            event.preventDefault();
            showLoader(); 
            $('#registrationForm').submit();
        });
    }
 
    $('#book_owner_option').on('change', function() {
        if ($(this).is(':checked')) { 
            $('#promo_code').val('');
             
            $('#promo_code_section').hide();
            $('#challenge_answer_section').show();
        }
    });

    $('#promo_code_option').on('change', function() {
        if ($(this).is(':checked')) { 
            $('#challenge_answer').val('');
             
            $('#challenge_answer_section').hide();
            $('#promo_code_section').show();
        }
    });

    function validatePromoCodeAjax() {
        const promoCode = promoCodeInput.value;
        const codeType = planOptionInput.value === 'challenge' ? 'registration' : 'discount';
     
        $.ajax({
            url: window.appData.validatePromoCode, 
            type: 'POST',
            data: {
                promo_code: promoCode,
                code_type: codeType,
                _token: window.appData.csrfToken
            },
            success: function(response) {
                if (response.success) {                     
                    form.submit();
                } else {                     
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Promo Code',
                        text: response.message,
                        confirmButtonText: 'Try again!'
                    });
                }
            },
            error: function(xhr) {
                hideLoader();
                const response = xhr.responseJSON;
                const errorMessage = response && response.message ? response.message : 'An error occurred. Please try again.';
                
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Promo Code',
                    text: errorMessage,
                    confirmButtonText: 'Try again!'
                });
            }
        });
    }
    
    function validateChallengeAnswerAjax() {
        const challengeAnswer = challengeAnswerInput.value;

        $.ajax({
            url: window.appData.validateChallengeAnswer,
            type: 'POST',
            data: {
                challenge_answer: challengeAnswer,
                challenge_page: challengePage,
                _token: window.appData.csrfToken
            },
            success: function(response) {
                if (response.success) {
                    form.submit();
                } else {
                    const challengeErrorDiv = document.getElementById('challengeErrorDiv');
                    if (challengeErrorDiv) {
                        challengeErrorDiv.innerText = response.errors;
                        challengeErrorDiv.style.display = 'block';
                    }
                    registerButton.disabled = false;
                }
            },
            error: function(xhr) {
                hideLoader();
                

                const response = xhr.responseJSON;

                const errorMessage = response && response.errors ? response.errors : 'An error occurred. Please try again.';

                Swal.fire({
                    icon: 'warning',
                    title: 'Oops! Wrong Keyword',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });

                registerButton.disabled = false;
            }
        });

        registerButton.disabled = true;
        
    }

    function showForm(option) {
        
        planSelection.style.display = 'none'; 
        registrationFormContainer.style.display = 'block'; 
        planOptionInput.value = option;

        const discountCodeSection = document.getElementById('discount_code_section');

        if (option === 'challenge') {
            formHeader.innerText = 'Book Registration';
            challengeOptionSection.style.display = 'block'; 
            challengeAnswerSection.style.display = 'block'; 
            promoCodeSection.style.display = 'none'; 
            registerButton.style.display = 'inline-block'; 
            proceedToPaymentButton.style.display = 'none'; 
            discountCodeSection.style.display = 'none';

            document.getElementById('bookText').style.display = 'block';
            document.getElementById('bookPlanDetails').style.display = 'block';
            
        } else if (option === 'standard') {
            formHeader.innerText = 'Standard Plan';
            challengeOptionSection.style.display = 'none'; 
            challengeAnswerSection.style.display = 'none'; 
            promoCodeSection.style.display = 'none'; 
            registerButton.style.display = 'none'; 
            proceedToPaymentButton.style.display = 'inline-block'; 
            discountCodeSection.style.display = 'block'

            document.getElementById('planText').style.display = 'block';
            document.getElementById('standardPlanDetails').style.display = 'block';
        } else if (option === 'premium') {
            formHeader.innerText = 'Premium Plan';
            challengeOptionSection.style.display = 'none'; 
            challengeAnswerSection.style.display = 'none'; 
            promoCodeSection.style.display = 'none'; 
            registerButton.style.display = 'none'; 
            proceedToPaymentButton.style.display = 'inline-block'; 
            discountCodeSection.style.display = 'block';

            document.getElementById('planText').style.display = 'block';
            document.getElementById('premiumPlanDetails').style.display = 'block';
        } 
        
        initializeFormValidation(option);
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    const emailInput = document.getElementById('email');

    if (emailInput) {
        emailInput.addEventListener('input', function() {
            clearTimeout(emailValidationTimeout);
            
            
            emailValidationTimeout = setTimeout(function() {
                validateEmailManually();
            }, 700);
        });
    } else {
        
    }

    
    let emailIsValid = true;
  
    function validateEmailManually() {
        clearTimeout(emailValidationTimeout);
         
        emailValidationTimeout = setTimeout(function() {
            const emailValue = $('#email').val();
           

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(emailValue)) {
                

                $('#email').removeClass('is-valid').addClass('is-invalid');
                
                $('#registrationForm').validate().element('#email');

                $('#registrationForm').validate().showErrors({
                    'email': window.validation.invalid_email
                });
                emailIsValid = false;
                return;
            }

            if (emailValue) {
                $.post('/check-email', { email: emailValue }, function(data) {
                    

                    if (data.exists === true) {
                        
                        $('#email').removeClass('is-valid').addClass('is-invalid');

                        $('#registrationForm').validate().element('#email');

                        $('#registrationForm').validate().showErrors({
                        'email': window.validation.email_exists
                        });
                        emailIsValid = false;
                    } else if (data.exists === false) {
                        
                        $('#email').removeClass('is-invalid').addClass('is-valid');
                        $('#email-error').text('').hide();
                        emailIsValid = true;
                    } else {
                        
                        emailIsValid = false;
                    }
                }).fail(function(xhr, status, error) {
                    console.error('Error validating email: ', error, ' Status: ', status, ' Detalhes: ', xhr);
                    $('#email').removeClass('is-valid').addClass('is-invalid');

                    $('#registrationForm').validate().element('#email');

                    $('#registrationForm').validate().showErrors({
                        'email': window.validation.email_required 
                    });
                    emailIsValid = false;
                });
            } else {
                
                $('#email').removeClass('is-valid').addClass('is-invalid');

                $('#registrationForm').validate().element('#email');

                emailIsValid = false;
            }
        }, 100);
    }

    $.validator.addMethod('recaptchaChecked', function() { 
        return grecaptcha && grecaptcha.getResponse().length !== 0;
    }, 'Please confirm you are not a robot.');
    
    function initializeFormValidation(option) { 
        const validator = $('#registrationForm').validate({ 
            onsubmit: true,
             
            ignore: [],
            
            rules: {
                name: {
                    required: true,
                    nameValidation: true
                },
                password: {
                    required: true,
                    minlength: 8,
                    passwordComplexity: true,
                    noUserNameInPassword: true
                },
                password_confirmation: {
                    required: true,
                    equalTo: '#password'
                },
                terms: {
                    required: true
                },
                'g-recaptcha-response': {
                    required: function() {
                        return $('input[name="captcha_status"]').val() === 'true' || 
                               $('input[name="captcha_status"]').val() === '1';
                    },
                    recaptchaChecked: function() {
                        return $('input[name="captcha_status"]').val() === 'true' || 
                               $('input[name="captcha_status"]').val() === '1';
                    }
                },
                challenge_answer: {
                    required: function() {
                        return planOptionInput.value === 'challenge' && $('#book_owner_option').is(':checked');
                    }
                }, 
                promo_code: {
                    required: function() {
                        return planOptionInput.value === 'challenge' && $('#promo_code_option').is(':checked');
                    }
                }
            },
            submitHandler: function(form) {
                if (!emailIsValid) {
                    hideLoader();
                    $('#email').focus();
                    return false;
                }
    
                if (planOptionInput.value === 'challenge') {
                    const promoCodeChecked = $('#promo_code_option').is(':checked');
                    if (promoCodeChecked) {
                        validatePromoCodeAjax();
                    } else {
                        validateChallengeAnswerAjax();
                    }
                } else {
                    startPaymentProcess();
                }
            },
            invalidHandler: function(event, validator) {
                $('#registerButton').prop('disabled', false);
                hideLoader();
            },
            messages: {
                name: {
                    required: window.validation.full_name_required,
                    nameValidation: window.validation.valid_name_required
                },
                password: {
                    required: window.validation.password_required,
                    minlength: window.validation.password_min_length,
                    passwordComplexity: window.validation.password_complexity,
                    noUserNameInPassword: window.validation.username_in_password
                },
                password_confirmation: {
                    required: window.validation.confirm_password,
                    equalTo: window.validation.passwords_match
                },
                terms: {
                    required: window.validation.terms_required
                }, 
                'g-recaptcha-response': {
                    required: 'Please complete the reCAPTCHA verification.',
                    recaptchaChecked: 'Please confirm you are not a robot.'
                },
                challenge_answer: {
                    required: window.validation.ownership_verification
                },
            },
            errorElement: 'div',
            errorPlacement: function(error, element) {
                if (element.is('input[type="checkbox"]')) {
                    error.addClass('invalid-feedback');
                    error.insertAfter(element.next('label'));
                } else if (element.attr('name') === 'g-recaptcha-response') { 
                    error.addClass('invalid-feedback');
                    error.insertAfter($('.g-recaptcha'));
                } else {
                    error.addClass('invalid-feedback');
                    error.insertAfter(element);
                }     
                
                setTimeout(function() {
                    error.fadeOut(500, function() { $(this).remove(); });
                }, 3000);          
            }
        });
    }

    $.validator.addMethod('nameValidation', function(value) { 
        var nameParts = value.trim().split(/\s+/); 
        return nameParts.length === 2;
    }, $.validator.messages.nameValidation);

    $.validator.addMethod("noUserNameInPassword", function(value, element) {
        var fullName = $('#name').val();
        var nameParts = fullName.split(/\s+/);
        return this.optional(element) || !nameParts.some(part => value.includes(part));
    });

    $.validator.addMethod('passwordComplexity', function(value, element) {
        return this.optional(element) || /^(?=.*[a-zA-Z])(?=.*\d)(?=.*\W).+$/.test(value);
    });
 
    const selectChallengeAnswer = document.getElementById('selectChallengeAnswer');
    if (selectChallengeAnswer) {
        selectChallengeAnswer.addEventListener('click', function() {
            showForm('challenge');
        });
    }
 
    const selectStandardPlan = document.getElementById('selectStandardPlan');
    if (selectStandardPlan) {
        selectStandardPlan.addEventListener('click', function() {
            showForm('standard');
        });
    }
 
    const selectPremiumPlan = document.getElementById('selectPremiumPlan');
    if (selectPremiumPlan) {
        selectPremiumPlan.addEventListener('click', function() {
            showForm('premium');
        });
    }
 
    if (proceedToPaymentButton) {
        proceedToPaymentButton.addEventListener('click', function(event) {
            event.preventDefault();
            showLoader();
 
            $('#registrationForm').validate({
                submitHandler: function(form) {
                    startPaymentProcess(); 
                },
                invalidHandler: function(event, validator) {
                    hideLoader(); 
                }
            });

            $('#registrationForm').submit(); 
        });
    } 

    function startPaymentProcess() {        
        if (typeof stripe !== 'undefined') {
            const subscriptionType = formHeader.innerText.includes('Standard') ? 'standard' : 'premium';            
            
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const password = document.getElementById('password').value;
            const discountCode = document.getElementById('appliedDiscountCode').value;
    
            if (!name || !email || !password) {
                hideLoader();
                return;
            }
    
            fetch('/create-checkout-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    subscription_type: subscriptionType,
                    name: name,
                    email: email,
                    password: password,
                    discount_code: discountCode
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.checkoutSessionId) {
                    return stripe.redirectToCheckout({ sessionId: data.checkoutSessionId });
                } else {
                    throw new Error('Error creating payment session.');
                }
            })
            .catch(error => {
                hideLoader();
            });
        } else {
            alert("The Stripe service is currently unavailable. Payment cannot be processed at this time.");
            hideLoader();
        }
    }
    

    function showLoader() {
        $('#loader2').removeClass('fade-out');
    }

    function hideLoader() {
        $('#loader2').addClass('fade-out');
    }

    const renewChallengeButton = document.getElementById('renewChallengeWord');

    if (renewChallengeButton) {
        renewChallengeButton.addEventListener('click', function() {
            fetch(window.appData.renewChallengeWordUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': window.appData.csrfToken
                }
            })
            .then(response => response.json())
            .then(data => {
                document.getElementById('challenge_page').innerText = data.randomPage;
            })
            .catch(error => console.error('Error:', error));
        });
    }

    const planOption = document.getElementById('plan_option');
    const discountCodeInput = document.getElementById('discount_code');
    const discountMessage = document.getElementById('discountMessage');
    const discountMessageSuccess = document.getElementById('discountMessageSuccess');

    if (standardPlanDetails) {
        standardPlanDetails.addEventListener('click', function() {
            planOption.value = 'standard';
        });
    }

    if (premiumPlanDetails) {
        premiumPlanDetails.addEventListener('click', function() {
            planOption.value = 'premium';
        });
    }

    if (bookPlanDetails) {
        bookPlanDetails.addEventListener('click', function() {
            planOption.value = 'challenge';
        });
    }


    function applyDiscountCode() {
        const discountCode = discountCodeInput.value;
        const selectedPlanType = planOption.value;
        const applyButton = document.querySelector('button[onclick="applyDiscountCode()"]');
         
        applyButton.disabled = true;
        const originalButtonText = applyButton.innerHTML;
        applyButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Applying...';
        
        fetch('/apply-discount-code', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({ discount_code: discountCode, subscription_type: selectedPlanType })
        })
        .then(response => response.json())
        .then(data => { 
            applyButton.innerHTML = originalButtonText;
            
            if (data.success) {
                discountMessageSuccess.innerText = `Discount Applied: ${data.discount_percentage}% off`;
                document.getElementById('appliedDiscountCode').value = discountCode;
    
                const priceElement = selectedPlanType === 'standard' ? document.getElementById('standardPriceAmount') : document.getElementById('premiumPriceAmount');
                const originalPriceElement = selectedPlanType === 'standard' ? document.getElementById('originalStandardPrice') : document.getElementById('originalPremiumPrice');
                
                const formattedPrice = Math.round(data.new_price / 100);
                priceElement.innerText = formattedPrice;
                originalPriceElement.style.display = 'inline';
                 
                priceElement.classList.add('price-animation');
                setTimeout(() => {
                    priceElement.classList.remove('price-animation');
                }, 500);
            } else {
                let countdown = 3;
                 
                discountMessage.innerText = `Invalid or Expired Discount Code - Try again in ${countdown}s`;
                
                const interval = setInterval(() => {
                    countdown--;
                    
                    if (countdown > 0) { 
                        discountMessage.innerText = `Invalid or Expired Discount Code - Try again in ${countdown}s`;
                    } else { 
                        clearInterval(interval);
                        discountMessage.innerText = '';
                        discountCodeInput.disabled = false;
                        applyButton.disabled = false;
                    }
                }, 1000);
            }
        })
        .catch(error => {
            applyButton.innerHTML = originalButtonText;
            applyButton.disabled = false;
            
            discountMessage.innerText = 'An error occurred. Please try again.';
            discountCodeInput.disabled = false;
        });
    }

    discountCodeInput.addEventListener('input', function() {
        discountMessage.innerText = '';
    });

    // Make `applyDiscountCode` available globally
    window.applyDiscountCode = applyDiscountCode;

});

function adjustDivHeight() {
    var navbarHeight = 68;
    var footerHeight = 77;
    var availableHeight = window.innerHeight - navbarHeight - footerHeight;
    document.getElementById('fh-div').style.minHeight = availableHeight + 'px';
}
window.onload = adjustDivHeight;
window.onresize = adjustDivHeight;


 